export interface ShouldRedirectToIdpUrlOnLoginParams {
    redirectToIdpUrlOnLogin: boolean;
    hasValidSession: boolean;
}

export function shouldRedirectToIdpUrlOnLogin({ redirectToIdpUrlOnLogin, hasValidSession }: ShouldRedirectToIdpUrlOnLoginParams): boolean {
    return redirectToIdpUrlOnLogin && !hasValidSession;
}
